module.exports = __webpack_public_path__ + "img/slider-image-11.d90fdd3d.jpg";